<template>
  <div class="dashboard-container-new">
    <!-- 顶部欢迎区域 -->
    <div class="top-section">
      <div class="welcome-card-new">
        <div class="user-info-new">
          <el-image
            :src="getCurrentUserAvater"
            alt="头像预览"
            class="user-avatar-new"
            :preview-src-list="[getCurrentUserAvater]"
            fit="cover"
          />
          <div class="user-text-new">
            <h2 class="welcome-title-new">
              {{ getCurrentTimeDesc }}，{{ getCurrentUser }}！欢迎登录
            </h2>
            <p class="welcome-subtitle-new">
              一站式智能管理解决方案，帮助您高效管理客户、快速提升业绩
            </p>
          </div>
        </div>
      </div>
    </div>



    <!-- 年度概览数据看板 -->
    <div class="data-dashboard-section">
      <div class="dashboard-header">
        <div class="header-content">
          <h2 class="dashboard-title">
            <i class="el-icon-data-analysis"></i>
            {{ currentYear }}年度经营数据看板
          </h2>
          <div class="header-actions">
            <el-tag type="success" effect="plain">实时更新</el-tag>
            <el-button 
              size="mini" 
              type="primary" 
              icon="el-icon-refresh" 
              @click="refreshDashboard"
              class="refresh-btn"
            >
              刷新数据
            </el-button>
          </div>
        </div>
      </div>
          
      <div class="metrics-grid">
        <!-- 核心指标卡片 -->
        <div 
          class="metric-card clean" 
          @click="toggleDisplayValue('totalAmount')"
        >
          <div class="card-icon sales-simple">
            <i class="el-icon-shopping-cart-2"></i>
          </div>
          <div class="card-content">
            <div class="metric-label">年度销售额</div>
            <div class="metric-value-wrapper">
              <span class="currency-symbol">¥</span>
              <span 
                class="metric-value-display" 
                :class="{ 'original': displayMode.totalAmount }"
              >
                {{ displayMode.totalAmount ? 
                  formatNumber(businessOverviewData.totalAmount || 0) : 
                  formatShortNumber(Number(businessOverviewData.totalAmount) || 0).value + formatShortNumber(Number(businessOverviewData.totalAmount) || 0).unit 
                }}
              </span>
            </div>
            <div class="growth-info" v-if="businessOverviewData.amountGrowthRate !== 0">
              <span class="growth-text" :class="businessOverviewData.amountGrowthRate > 0 ? 'positive' : 'negative'">
                {{ businessOverviewData.amountGrowthRate > 0 ? '+' : '' }}{{ businessOverviewData.amountGrowthRate.toFixed(2) }}%
              </span>
              <span class="growth-label">同比去年</span>
            </div>
          </div>
        </div>
    
        <div 
          class="metric-card clean" 
          @click="toggleDisplayValue('orderCount')"
        >
          <div class="card-icon orders-simple">
            <i class="el-icon-document"></i>
          </div>
          <div class="card-content">
            <div class="metric-label">订单总数</div>
            <div class="metric-value-wrapper">
              <span 
                class="metric-value-display" 
                :class="{ 'original': displayMode.orderCount }"
              >
                {{ displayMode.orderCount ? 
                  formatNumber(businessOverviewData.orderCount || 0) : 
                  formatShortNumber(businessOverviewData.orderCount || 0).value + formatShortNumber(businessOverviewData.orderCount || 0).unit 
                }}
              </span>
              <span class="unit" v-if="!displayMode.orderCount">单</span>
            </div>
            <div class="growth-info" v-if="businessOverviewData.orderGrowthRate !== 0">
              <span class="growth-text" :class="businessOverviewData.orderGrowthRate > 0 ? 'positive' : 'negative'">
                {{ businessOverviewData.orderGrowthRate > 0 ? '+' : '' }}{{ businessOverviewData.orderGrowthRate.toFixed(2) }}%
              </span>
              <span class="growth-label">同比去年</span>
            </div>
          </div>
        </div>
    
        <div 
          class="metric-card clean" 
          @click="toggleDisplayValue('customerCount')"
        >
          <div class="card-icon customers-simple">
            <i class="el-icon-user"></i>
          </div>
          <div class="card-content">
            <div class="metric-label">新增客户</div>
            <div class="metric-value-wrapper">
              <span 
                class="metric-value-display" 
                :class="{ 'original': displayMode.customerCount }"
              >
                {{ displayMode.customerCount ? 
                  formatNumber(businessOverviewData.customerCount || 0) : 
                  formatShortNumber(businessOverviewData.customerCount || 0).value + formatShortNumber(businessOverviewData.customerCount || 0).unit 
                }}
              </span>
              <span class="unit" v-if="!displayMode.customerCount">人</span>
            </div>
            <div class="growth-info" v-if="businessOverviewData.customerGrowthRate !== 0">
              <span class="growth-text" :class="businessOverviewData.customerGrowthRate > 0 ? 'positive' : 'negative'">
                {{ businessOverviewData.customerGrowthRate > 0 ? '+' : '' }}{{ businessOverviewData.customerGrowthRate.toFixed(2) }}%
              </span>
              <span class="growth-label">同比去年</span>
            </div>
          </div>
        </div>
    
        <div 
          class="metric-card clean" 
          @click="toggleDisplayValue('totalProductCount')"
        >
          <div class="card-icon products-simple">
            <i class="el-icon-goods"></i>
          </div>
          <div class="card-content">
            <div class="metric-label">累销产品</div>
            <div class="metric-value-wrapper">
              <span 
                class="metric-value-display" 
                :class="{ 'original': displayMode.totalProductCount }"
              >
                {{ displayMode.totalProductCount ? 
                  formatNumber(businessOverviewData.totalProductCount || 0) : 
                  formatShortNumber(businessOverviewData.totalProductCount || 0).value + formatShortNumber(businessOverviewData.totalProductCount || 0).unit 
                }}
              </span>
              <span class="unit" v-if="!displayMode.totalProductCount">件</span>
            </div>
            <div class="highlight-tag">
              核心SKU
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 - 四个图表按2x2布局 -->
    <div class="main-content-section">
      <!-- 第一行 -->
      <el-row :gutter="20" class="chart-row">
        <!-- 销售额汇总分析 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="chart-col">
          <div class="chart-area">
            <div class="chart-header-new">
              <h3 class="chart-title-new">销售额汇总分析</h3>
              <div class="chart-filter">
                <el-select
                  v-model="selectedYear"
                  @change="handleSalesYearChange"
                  placeholder="选择年份"
                  size="small"
                  class="filter-select-small"
                >
                  <el-option v-for="year in yearOptions" :key="year" :label="year" :value="year">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="chart-content-new">
              <div id="sales_chart" class="chart-container-new" v-loading="amountLoading"></div>
            </div>
          </div>
        </el-col>

        <!-- 热门销售产品占比 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="chart-col">
          <div class="chart-area">
            <div class="chart-header-new">
              <h3 class="chart-title-new">热门销售产品TOP10</h3>
              <div class="chart-filter">
                <el-select
                  v-model="selectedProductYear"
                  @change="handleProductYearChange"
                  placeholder="选择年份"
                  size="small"
                  class="filter-select-small"
                >
                  <el-option v-for="year in yearOptions" :key="year" :label="year" :value="year">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="chart-content-new">
              <div id="product_chart" class="chart-container-new" v-loading="amountLoading"></div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第二行 -->
      <el-row :gutter="20" class="chart-row mt-20">
        <!-- 订单趋势 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="chart-col">
          <div class="chart-area">
            <div class="chart-header-new">
              <h3 class="chart-title-new">订单趋势</h3>
              <div class="chart-filter">
                <el-select
                  v-model="selectedOrderYear"
                  @change="handleOrderYearChange"
                  placeholder="选择年份"
                  size="small"
                  class="filter-select-small"
                >
                  <el-option v-for="year in yearOptions" :key="year" :label="year" :value="year">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="chart-content-new">
              <div id="order_chart" class="chart-container-new" v-loading="amountLoading"></div>
            </div>
          </div>
        </el-col>

        <!-- 客户趋势 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="chart-col">
          <div class="chart-area">
            <div class="chart-header-new">
              <h3 class="chart-title-new">客户趋势</h3>
              <div class="chart-filter">
                <el-select
                  v-model="selectedCustomYear"
                  @change="handleCustomYearChange"
                  placeholder="选择年份"
                  size="small"
                  class="filter-select-small"
                >
                  <el-option v-for="year in yearOptions" :key="year" :label="year" :value="year">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="chart-content-new">
              <div id="customer_chart" class="chart-container-new" v-loading="amountLoading"></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import CountTo from 'vue-count-to';

export default {
  name: "echarts",
  components: {
    CountTo,
  },
  data() {
    // 生成年份选项（从2024年开始）
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let i = 2024; i <= currentYear; i++) {
      yearOptions.push(i);
    }

    return {
      showDialog: false, // 是否显示弹窗
      updateSeen: false, // 是否已经查看更新
      showDetail: false, // 是否显示详细更新内容
      
      // 数值显示模式控制
      displayMode: {
        totalAmount: false,
        orderCount: false, 
        customerCount: false,
        totalProductCount: false
      },

      form: {
        customNum: '',
        orderNum: '',
        productNum: '',
      },
      orderData: {
        date: '',
        quantity: null,
      },
      salesChart: null, // 销售额图表实例
      productChart: null, // 产品图表实例
      orderChart: null, // 订单图表实例
      customerChart: null, // 客户图表实例
      orderCount: [],
      orderSubscript: [], // 订单数据横坐标
      customSubscript: [], // 客户数据横坐标
      customCount: [],
      amountSeriesData: [], // 销售额数据系列
      amountXAxisData: [], // 销售额数据横坐标
      orderTitle: "年度订单数量汇总",
      customTitle: "年度客户数量汇总",
      currentTime: new Date(),
      amount: {
        isConsistent: false,
        totalAmount: "",
        isProfit: true,
        compared: "同步去年",
        historyTitle: "去年总销售额",
        historicalAmount: "",
        percent: "",
      },
      // 当前年度数据（用于年度概览）
      currentYearAmount: {
        isConsistent: false,
        totalAmount: "",
        isProfit: true,
        historicalAmount: "",
      },
      // 经营概览完整数据
      businessOverviewData: {
        year: 0,
        totalAmount: 0,
        orderCount: 0,
        customerCount: 0,
        totalProductCount: 0,
        lastYearTotalAmount: 0,
        lastYearOrderCount: 0,
        lastYearCustomerCount: 0,
        amountGrowthRate: 0,
        orderGrowthRate: 0,
        customerGrowthRate: 0,
        isProfit: true
      },
      amountLoading: false,
      productCountData: [],
      productTitle: "年度热门产品销量排行",

      // 年份选项
      yearOptions,

      // 当前选择的年份
      selectedYear: currentYear,
      selectedProductYear: currentYear,
      selectedOrderYear: currentYear,
      selectedCustomYear: currentYear,

      // 当前年度（固定不变）
      currentYear: currentYear,
      currentYearOrderCount: [],
      currentYearCustomCount: []
    }
  },
  computed: {
    getCurrentTimeDesc() {
      const hours = this.currentTime.getHours();
      if (hours >= 5 && hours < 12) {
        return "上午好";
      } else if (hours >= 12 && hours < 14) {
        return "中午好";
      } else if (hours >= 14 && hours < 18) {
        return "下午好";
      } else {
        return "晚上好";
      }
    },
    getCurrentUser() {
      const loginInfo = localStorage.getItem("logininfo");
      if (!loginInfo) return '用户';
      try {
        const user = JSON.parse(loginInfo);
        return user.username || user.name || '用户';
      } catch (error) {
        console.error('解析用户信息失败:', error);
        return '用户';
      }
    },

    getCurrentUserAvater() {
      const loginInfo = localStorage.getItem("logininfo");
      if (!loginInfo) return '';
      try {
        const user = JSON.parse(loginInfo);
        return user.avatar || '';
      } catch (error) {
        console.error('解析用户头像信息失败:', error);
        return '';
      }
    },
    getPercent() {
      const nowAmount = this.amount.totalAmount;
      const lastAmount = this.amount.historicalAmount;
      if (lastAmount === 0 || !lastAmount) {
        // 如果去年金额为0，则无法计算百分比变化
        return "";
      }
      const changeAmount = nowAmount - lastAmount;
      const percent = (changeAmount / lastAmount) * 100;
      if (percent > 0) {
        return percent.toFixed(2);
      } else if (percent < 0) {
        return Math.abs(percent).toFixed(2);
      }
      return "";
    },
    getTopProduct() {
      if (this.productCountData && this.productCountData.length > 0) {
        const topProduct = this.productCountData.reduce((prev, current) =>
            (prev.value > current.value) ? prev : current
        );
        return topProduct.name;
      }
      return "暂无数据";
    },
    getMaxOrderDay() {
      if (this.orderSubscript && this.orderCount && this.orderSubscript.length > 0 && this.orderCount.length > 0) {
        const maxIndex = this.orderCount.indexOf(Math.max(...this.orderCount));
        return this.orderSubscript[maxIndex];
      }
      return "暂无数据";
    },
    getCustomerGrowthRate() {
      if (this.customCount && this.customCount.length > 1) {
        const current = this.customCount[this.customCount.length - 1];
        const previous = this.customCount[this.customCount.length - 2];
        if (previous !== 0) {
          return ((current - previous) / previous * 100).toFixed(2) + "%";
        }
      }
      return "0%";
    },


    // 计算当前年度同比增长率
    getCurrentYearPercent() {
      const nowAmount = this.currentYearAmount.totalAmount;
      const lastAmount = this.currentYearAmount.historicalAmount;
      if (lastAmount === 0 || !lastAmount) {
        return "";
      }
      const changeAmount = nowAmount - lastAmount;
      const percent = (changeAmount / lastAmount) * 100;
      if (percent > 0) {
        return percent.toFixed(2);
      } else if (percent < 0) {
        return Math.abs(percent).toFixed(2);
      }
      return "";
    },
  },
  mounted() {
    // 确保DOM渲染完成后初始化图表
    this.$nextTick(() => {
      this.$nextTick(() => {
        this.initAllCharts();
      });
    });
  
    // 获取所有数据
    this.initializeAllStatistics(this.selectedYear);
  
    // 初始化当前年度数据（用于年度概览）
    this.initializeCurrentYearData();
  },
  methods: {
    // 添加 formatNumber 方法
    formatNumber(value) {
      if (!value) return '0';
      return Number(value).toLocaleString();
    },

    // 数字格式化为简写形式 (K, W)
    formatShortNumber(num) {
      if (num >= 10000) {
        // 万以上用W表示
        return {
          value: parseFloat((num / 10000).toFixed(2)),
          unit: 'W',
          decimals: 2
        };
      } else if (num >= 1000) {
        // 千以上用K表示
        return {
          value: parseFloat((num / 1000).toFixed(1)),
          unit: 'K',
          decimals: 1
        };
      } else {
        // 一千以下直接显示
        return {
          value: num,
          unit: '',
          decimals: 0
        };
      }
    },

    // 切换数值显示模式
    toggleDisplayValue(field) {
      // 切换对应字段的显示模式
      this.displayMode[field] = !this.displayMode[field];
          
      // 复制当前显示的数值到剪贴板
      const currentValue = this.businessOverviewData[field] || 0;
      const displayValue = this.displayMode[field] ? 
        currentValue.toString() : 
        this.formatShortNumber(Number(currentValue)).value + this.formatShortNumber(Number(currentValue)).unit;
          
      navigator.clipboard.writeText(displayValue).catch(err => {
        // 静默处理复制错误
      });
    },

    // 刷新数据看板
    refreshDashboard() {
      this.$message({
        message: '正在刷新数据...',
        type: 'info',
        duration: 1000
      });

      // 重新初始化当前年度数据
      this.initializeCurrentYearData();

      // 同时刷新图表数据
      this.initializeAllStatistics(this.selectedYear);
    },

      // 获取销售额统计数据
      getAmountStatisticsOnly(year) {
        this.amountLoading = true;

        this.getAmountStatistics(year)
            .then(() => {
              this.amountLoading = false;
              this.$nextTick(() => {
                this.updateSalesChart();
              });
            })
            .catch(() => {
              this.amountLoading = false;
            });
      },

      // 获取产品统计数据
      getProductStatistics(year) {
        if (!year) {
          return Promise.reject(new Error('year参数不能为空'));
        }
        return this.$http.get('/product/getProductStatistics', {
              params: { time: year.toString() }
        }).then(res => {
          if (res.data.success) {
            const data = res.data.resultObj.data || res.data.resultObj;
            this.productCountData = Array.isArray(data) ? data : [];
            this.$nextTick(() => {
              this.updateProductChart();
            });
          }
        }).catch(() => {});
      },

      // 获取产品统计数据
      getProductStatisticsOnly(year) {
        this.getProductStatistics(year)
            .then(() => {
              this.$nextTick(() => {
                this.updateProductChart();
              });
            })
            .catch(() => {});
      },

      // 获取订单统计数据
      getOrderStatistics(year) {
        if (!year) {
          return Promise.reject(new Error('year参数不能为空'));
        }

        return this.$http.get('/order/getOrderStatistics', {
          params: { time: year.toString() }
        }).then(res => {
          if (res.data.success) {
            const data = res.data.resultObj;
            this.orderCount = data.count || [];
            this.orderSubscript = data.subscript || [];
            this.$nextTick(() => {
              this.updateOrderChart();
            });
          }
        }).catch(() => {});
      },

      // 获取订单统计数据
      getOrderStatisticsOnly(year) {
        this.getOrderStatistics(year)
            .then(() => {
              this.$nextTick(() => {
                this.updateOrderChart();
              });
            })
            .catch(() => {});
      },

      // 获取客户统计数据
      getCustomerStatistics(year) {
        if (!year) {
          return Promise.reject(new Error('year参数不能为空'));
        }

        return this.$http.get('/customer/getCustomerStatistics', {
          params: { time: year.toString() }
        }).then(res => {
          if (res.data.success) {
            const data = res.data.resultObj;
            this.customCount = data.count || [];
            this.customSubscript = data.subscript || [];
            this.$nextTick(() => {
              this.updateCustomerChart();
            });
          }
        }).catch(() => {});
      },

      // 获取客户统计数据
      getCustomerStatisticsOnly(year) {
        this.getCustomerStatistics(year)
            .then(() => {
              this.$nextTick(() => {
                this.updateCustomerChart();
              });
            })
            .catch(() => {});
      },

      // 初始化所有图表
      initAllCharts() {
        // 初始化销售额图表
        const salesDom = document.getElementById('sales_chart');
        if (salesDom && !this.salesChart) {
          this.salesChart = echarts.init(salesDom);
        }

        // 初始化产品图表
        const productDom = document.getElementById('product_chart');
        if (productDom && !this.productChart) {
          this.productChart = echarts.init(productDom);
        }

        // 初始化订单图表
        const orderDom = document.getElementById('order_chart');
        if (orderDom && !this.orderChart) {
          this.orderChart = echarts.init(orderDom);
        }

        // 初始化客户图表
        const customerDom = document.getElementById('customer_chart');
        if (customerDom && !this.customerChart) {
          this.customerChart = echarts.init(customerDom);
        }

        // 更新所有图表
        this.updateSalesChart();
        this.updateProductChart();
        this.updateOrderChart();
        this.updateCustomerChart();
      },

      // 初始化所有统计数据
      initializeAllStatistics(year) {
        if (!year) {
          this.amountLoading = false;
          return;
        }

        this.amountLoading = true;

        Promise.all([
          this.getAmountStatistics(year),
          this.getProductStatistics(year),
          this.getOrderStatistics(year),
          this.getCustomerStatistics(year)
        ]).then(() => {
          this.amountLoading = false;
          this.$nextTick(() => {
            this.updateSalesChart();
            this.updateProductChart();
            this.updateOrderChart();
            this.updateCustomerChart();
          });
        }).catch(() => {
          this.amountLoading = false;
        });
      },

      // 获取销售额统计数据
      getAmountStatistics(year) {
        if (!year) {
          return Promise.reject(new Error('year参数不能为空'));
        }

        return this.$http.get('/amount/getAmountStatistics', {
          params: { time: year.toString() }
        }).then(res => {
          if (res.data.success) {
            const data = res.data.resultObj;
            this.amountSeriesData = data.seriesData || [];
            this.amountXAxisData = data.xAxisData || [];
          }
        }).catch(() => {});
      },


      // 公共年份选择方法
      handleCommonYearChange(year, chartType) {
        switch(chartType) {
          case 'sales':
            this.selectedYear = year;
            this.getAmountStatisticsOnly(year);
            break;
          case 'product':
            this.selectedProductYear = year;
            this.getProductCountByYear(year);
            break;
          case 'order':
            this.selectedOrderYear = year;
            this.getOrderCountByYear(year);
            break;
          case 'custom':
            this.selectedCustomYear = year;
            this.getCustomCountByYear(year);
            break;
        }
      },

      // 销售额图表年份选择
      handleSalesYearChange(year) {
        this.handleCommonYearChange(year, 'sales');
      },

      // 产品图表年份选择
      handleProductYearChange(year) {
        this.handleCommonYearChange(year, 'product');
      },

      // 订单图表年份选择
      handleOrderYearChange(year) {
        this.handleCommonYearChange(year, 'order');
      },

      // 客户图表年份选择
      handleCustomYearChange(year) {
        this.handleCommonYearChange(year, 'custom');
      },


      // 按年份获取总额
      getTotalAmountByYear(year) {
        this.amountLoading = true;
        this.getAmountStatistics(year)
            .then(() => {
              this.amountLoading = false;
              this.$nextTick(() => {
                this.updateSalesChart();
              });
            })
            .catch(() => {
              this.amountLoading = false;
            });
      },



      // 按年份获取产品数据
      getProductCountByYear(year) {
        this.productTitle = `${year}年热门产品销量排行`;
        this.getProductStatisticsOnly(year);
      },



      // 按年份获取订单数据
      getOrderCountByYear(year) {
        this.orderTitle = `${year}年订单数量汇总`;
        this.getOrderStatisticsOnly(year);
      },



      // 按年份获取客户数据
      getCustomCountByYear(year) {
        this.customTitle = `${year}年客户数量汇总`;
        this.getCustomerStatisticsOnly(year);
      },



      // 更新销售额图表
      updateSalesChart() {
        if (!this.salesChart) {
          // 如果图表实例不存在，尝试重新初始化
          const salesDom = document.getElementById('sales_chart');
          if (salesDom) {
            this.salesChart = echarts.init(salesDom);
          } else {
            console.warn('销售额图表DOM元素不存在');
            return;
          }
        }

        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            top: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.amountXAxisData.length > 0 ? this.amountXAxisData : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                formatter: '¥{value}'
              }
            }
          ],
          series: [
            {
              name: '销售额',
              type: 'line',
              stack: '总量',
              areaStyle: {},
              data: this.amountSeriesData.length > 0 ? this.amountSeriesData : [120000, 132000, 101000, 134000, 90000, 230000, 210000, 180000, 190000, 200000, 220000, 250000],
              smooth: true,
              itemStyle: {
                color: '#5cb87a'
              },
              lineStyle: {
                color: '#5cb87a'
              }
            }
          ]
        };

        this.salesChart.setOption(option);
      },

      // 更新产品图表
      updateProductChart() {
        if (!this.productChart) {
          // 如果图表实例不存在，尝试重新初始化
          const productDom = document.getElementById('product_chart');
          if (productDom) {
            this.productChart = echarts.init(productDom);
          } else {
            console.warn('产品图表DOM元素不存在');
            return;
          }
        }

        // 准备产品数据
        const topProducts = this.productCountData.slice(0, 10);
        const productNames = topProducts.map(item => item.name) || [
          '宠物食品A', '宠物玩具B', '美容用品C', '营养补充D',
          '清洁用品E', '服装配件F', '训练器材G', '医疗用品H',
          '出行装备I', '智能家居J'
        ];
        const productValues = topProducts.map(item => item.value) || [
          1200, 1100, 1000, 900, 800, 700, 600, 500, 400, 300
        ];

        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: function(params) {
              const param = params[0];
              return `${param.name}<br/>销售数量: ${param.value} 件`;
            }
          },
          grid: {
            left: '8%',
            right: '18%',
            bottom: '15%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            name: '销售数量(件)',
            nameLocation: 'middle',
            nameGap: 30,
            nameTextStyle: {
              fontSize: 12,
              color: '#666'
            },
            axisLabel: {
              formatter: function(value) {
                if (value >= 1000) {
                  return (value / 1000).toFixed(1) + 'k';
                }
                return value;
              },
              color: '#666'
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                opacity: 0.3
              }
            }
          },
          yAxis: {
            type: 'category',
            data: productNames,
            axisLabel: {
              interval: 0,
              rotate: 0,
              fontSize: 12,
              fontWeight: 'normal',
              color: '#333'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#ddd'
              }
            },
            axisTick: {
              show: false
            }
          },
          series: [{
            name: '销售数量',
            type: 'bar',
            data: productValues,
            barWidth: '55%',
            itemStyle: {
              color: function(params) {
                // 蓝色系渐变色彩方案
                const colors = ['#409EFF', '#53A8FF', '#66B1FF', '#79BBFF', '#8CC5FF',
                               '#9FCEFF', '#B2D8FF', '#C5E1FF', '#D8EAFF', '#EBF4FF'];
                return colors[params.dataIndex % colors.length];
              },
              borderRadius: [0, 8, 8, 0],
              shadowColor: 'rgba(64, 158, 255, 0.2)',
              shadowBlur: 8,
              shadowOffsetY: 3
            },
            label: {
              show: true,
              position: 'right',
              formatter: function(params) {
                return params.value + ' 件';
              },
              fontSize: 11,
              color: '#666',
              fontWeight: 'bold'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 15,
                shadowColor: 'rgba(64, 158, 255, 0.4)'
              }
            }
          }]
        };

        this.productChart.setOption(option);
      },

      // 更新订单图表
      updateOrderChart() {
        if (!this.orderChart) {
          // 如果图表实例不存在，尝试重新初始化
          const orderDom = document.getElementById('order_chart');
          if (orderDom) {
            this.orderChart = echarts.init(orderDom);
          } else {
            console.warn('订单图表DOM元素不存在');
            return;
          }
        }

        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.orderSubscript || ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '订单量',
            type: 'line',
            stack: '总量',
            areaStyle: {},
            data: this.orderCount || [120, 132, 101, 134, 90, 230, 210, 180, 190, 200, 220, 250],
            smooth: true,
            itemStyle: {
              color: '#67C23A'
            },
            lineStyle: {
              color: '#67C23A'
            }
          }]
        };

        this.orderChart.setOption(option);
      },

      // 更新客户图表
      updateCustomerChart() {
        if (!this.customerChart) {
          // 如果图表实例不存在，尝试重新初始化
          const customerDom = document.getElementById('customer_chart');
          if (customerDom) {
            this.customerChart = echarts.init(customerDom);
          } else {
            console.warn('客户图表DOM元素不存在');
            return;
          }
        }

        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.customSubscript || ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '新增客户数',
            type: 'line',
            stack: '总量',
            areaStyle: {},
            data: this.customCount || [320, 302, 341, 374, 390, 450, 420, 380, 390, 400, 410, 430],
            smooth: true,
            itemStyle: {
              color: '#409EFF'
            },
            lineStyle: {
              color: '#409EFF'
            }
          }]
        };

        this.customerChart.setOption(option);
      },



      // 导出数据
      exportData() {
        alert('数据导出功能正在开发中...');
      },

      // 初始化当前年度数据（用于年度概览）
      initializeCurrentYearData() {
        this.getBusinessOverview(this.currentYear)
            .then(res => {
              if (res.data.success) {
                const data = res.data.resultObj;
                this.businessOverviewData = {
                  year: data.year,
                  totalAmount: data.totalAmount,
                  orderCount: data.orderCount,
                  customerCount: data.customerCount,
                  totalProductCount: data.totalProductCount,
                  lastYearTotalAmount: data.lastYearTotalAmount,
                  lastYearOrderCount: data.lastYearOrderCount,
                  lastYearCustomerCount: data.lastYearCustomerCount,
                  amountGrowthRate: data.amountGrowthRate,
                  orderGrowthRate: data.orderGrowthRate,
                  customerGrowthRate: data.customerGrowthRate,
                  isProfit: data.isProfit
                };

                this.currentYearAmount.isProfit = data.isProfit;
                this.currentYearAmount.totalAmount = data.totalAmount;
                this.currentYearAmount.historicalAmount = data.lastYearTotalAmount;
                this.currentYearAmount.isConsistent = Math.abs(data.amountGrowthRate) < 0.01;
              } else {
                this.fallbackInitializeData();
              }
            })
            .catch(() => {
              this.fallbackInitializeData();
            });
      },

      // 获取经营状态概览数据
      getBusinessOverview(year) {
        return this.$http.get('/business/overview', {
          params: { year: year }
        });
      },

      // 降级初始化方法（当新接口不可用时使用）
      fallbackInitializeData() {
        this.getAmountStatistics(this.currentYear)
            .then(res => {
              if (res.data.success) {
                const data = res.data.resultObj;
                this.currentYearAmount.isProfit = data.isProfit;
                this.currentYearAmount.totalAmount = data.totalAmount;
                this.currentYearAmount.historicalAmount = data.lastAmount;
                this.currentYearAmount.isConsistent = data.isConsistent;
              }
            })
            .catch(() => {});

        this.getOrderStatistics(this.currentYear)
            .then(res => {
              if (res.data.success) {
                const data = res.data.resultObj;
                this.currentYearOrderCount = data.count || [];
              }
            })
            .catch(() => {});

        this.getCustomerStatistics(this.currentYear)
            .then(res => {
              if (res.data.success) {
                const data = res.data.resultObj;
                this.currentYearCustomCount = data.count || [];
              }
            })
            .catch(() => {});
      },

      // 测试后端连接
      testBackendConnection() {
        this.getAmountStatistics('Annual', new Date().getFullYear().toString())
            .then(() => {})
            .catch(() => {});
      }
    }

}
</script>

<style scoped>
/* 新的样式定义 */
.dashboard-container-new {
  padding: 20px;
  background-color: #ffffff;
  min-height: 100vh;
}

.top-section {
  margin-bottom: 20px;
}

.welcome-card-new {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  padding: 20px;
  color: white;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.user-info-new {
  display: flex;
  align-items: center;
}

.user-avatar-new {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3px solid rgba(255,255,255,0.3);
  margin-right: 15px;
}

.user-text-new h2 {
  margin: 0 0 5px 0;
  font-size: 1.5em;
}

.user-text-new p {
  margin: 0;
  opacity: 0.9;
}



/* 简洁数据看板样式 */
.data-dashboard-section {
  margin-bottom: 28px;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.dashboard-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.dashboard-title {
  margin: 0;
  font-size: 1.6em;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 12px;
}

.dashboard-title i {
  font-size: 1.3em;
  color: #409eff;
}

.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.refresh-btn {
  transition: all 0.3s ease;
}

.refresh-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.metric-card.clean {
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.03);
}

.metric-card.clean:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.1);
  border-color: #409eff;
}

.card-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #ffffff;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.card-icon.sales-simple {
  background-color: #f56c6c;
}

.card-icon.orders-simple {
  background-color: #409eff;
}

.card-icon.customers-simple {
  background-color: #67c23a;
}

.card-icon.products-simple {
  background-color: #e6a23c;
}

.metric-card.clean:hover .card-icon {
  transform: scale(1.05);
}

.card-content {
  flex: 1;
}

.metric-label {
  font-size: 0.85em;
  font-weight: 500;
  color: #909399;
  margin-bottom: 10px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.metric-value-wrapper {
  display: flex;
  align-items: baseline;
  gap: 3px;
  margin-bottom: 10px;
}

.currency-symbol {
  font-size: 1.1em;
  color: #909399;
  font-weight: 500;
}

.metric-value-display {
  font-size: 2em;
  font-weight: 700;
  line-height: 1.1;
  color: #303133;
  font-family: 'DIN Alternate', 'Arial', sans-serif;
  letter-spacing: -0.5px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.metric-value-display.original {
  color: #409eff;
  text-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
  animation: pulseGlow 2s infinite;
}

@keyframes pulseGlow {
  0% { text-shadow: 0 0 8px rgba(64, 158, 255, 0.3); }
  50% { text-shadow: 0 0 12px rgba(64, 158, 255, 0.5); }
  100% { text-shadow: 0 0 8px rgba(64, 158, 255, 0.3); }
}

.metric-card.clean:hover .metric-value-display:not(.original) {
  color: #409eff;
}

.unit {
  font-size: 1em;
  color: #909399;
  font-weight: 500;
  font-family: 'Arial', sans-serif;
}

.growth-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.growth-text {
  font-size: 0.85em;
  font-weight: 600;
}

.growth-text.positive {
  color: #67c23a;
}

.growth-text.negative {
  color: #f56c6c;
}

.growth-label {
  font-size: 0.8em;
  color: #c0c4cc;
}

.highlight-tag {
  display: inline-block;
  padding: 2px 10px;
  background-color: #fdf6ec;
  color: #e6a23c;
  border-radius: 12px;
  font-size: 0.75em;
  font-weight: 500;
  border: 1px solid #f5dab1;
}


/* 响应式设计 */
@media (max-width: 1200px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .data-dashboard-section {
    padding: 20px 16px;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .dashboard-title {
    font-size: 1.4em;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .metric-card.clean {
    padding: 16px;
  }

  .card-icon {
    width: 45px;
    height: 45px;
    font-size: 18px;
  }

  .metric-value {
    font-size: 1.8em;
  }
}

@media (max-width: 480px) {
  .data-dashboard-section {
    border-radius: 10px;
  }

  .dashboard-title {
    font-size: 1.2em;
  }

  .metric-card.clean {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .metric-value-wrapper {
    justify-content: center;
  }

  .growth-info {
    justify-content: center;
  }
}

.main-content-section {
  min-height: 500px;
}

.chart-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.chart-col {
  padding: 0 10px;
  margin-bottom: 20px;
}

.chart-area {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  height: 450px;
  display: flex;
  flex-direction: column;
}

.mt-20 {
  margin-top: 20px;
}

.chart-header-new {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chart-title-new {
  margin: 0;
  font-size: 1.3em;
  color: #333;
}

.chart-filter {
  display: flex;
  gap: 10px;
  align-items: center;
}

.filter-select-small {
  width: 120px;
}

.chart-content-new {
  flex: 1;
  min-height: 350px;
}

.chart-container-new {
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .chart-filter {
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-select-small {
    width: 100%;
  }

  .overview-summary {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .summary-item {
    min-width: auto;
    width: 80%;
  }

  .overview-title {
    font-size: 1.5em;
  }
}
</style>



// WEBPACK FOOTER //
// echarts.vue?70bfd48a